import { EditorCommand, EditorPlugin, PluginFunctions } from "@draft-js-plugins/editor";
import { DraftHandleValue, EditorState, KeyBindingUtil, RichUtils } from "draft-js";
import { KeyboardEvent } from "react";
import { createLinkDecorators } from "./linkDecorators";

export const createAddLinkPlugin = ({ editable }: { editable: boolean }): EditorPlugin => {
	return {
		keyBindingFn(event: KeyboardEvent, pluginFunctions: PluginFunctions): EditorCommand | null | undefined {
			const { getEditorState } = pluginFunctions;
			const editorState = getEditorState();
			const selection = editorState.getSelection();

			if (!selection.isCollapsed() && KeyBindingUtil.hasCommandModifier(event) && event.which === 75) {
				return "add-link";
			}
			return;
		},

		handleKeyCommand(
			command: EditorCommand,
			editorState: EditorState,
			_eventTimeStamp: number,
			pluginFunctions: PluginFunctions
		): DraftHandleValue {
			const { setEditorState } = pluginFunctions;
			if (command !== "add-link") {
				return "not-handled";
			}
			const link = window.prompt("url...");
			const selection = editorState.getSelection();
			if (!link) {
				setEditorState(RichUtils.toggleLink(editorState, selection, null));
				return "handled";
			}
			const content = editorState.getCurrentContent();
			const contentWithEntity = content.createEntity("LINK", "MUTABLE", {
				url: link,
			});
			const newEditorState = EditorState.push(editorState, contentWithEntity, "apply-entity");
			const entityKey = contentWithEntity.getLastCreatedEntityKey();
			setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey));
			return "handled";
		},

		decorators: createLinkDecorators({ editable }),
	};
};
